import React from "react";

import { focusModeWhitelistedRoutes } from "@config/app.routing";
import { BODY_FOCUS_MODE_CLASS } from "@config/consts";

import { useMatchPath } from "@hooks/useMatchPath";

/**
 * This component is responsible for setting the focus class on the body element for whitelisted routes.
 */
const FocusModeController = (): null => {
  const matchPath = useMatchPath();

  const isWhitelistedRoute = focusModeWhitelistedRoutes.some(matchPath);

  React.useEffect(() => {
    const $body = document?.body;

    if (!$body) return;

    $body.classList.toggle(BODY_FOCUS_MODE_CLASS, isWhitelistedRoute);

    return () => {
      if (!$body) return;

      $body.classList.remove(BODY_FOCUS_MODE_CLASS);
    };
  }, [isWhitelistedRoute]);

  return null;
};

export { FocusModeController };
